function modifyBuyNowButton() {
  const lockIconUrl = 'https://cdn.shopify.com/s/files/1/0103/1890/5441/files/payment-btn-cta-icon-lock.png?v=1740643063';
  const srCtaButtonSelector = '#CartDrawer .shiprocket-headless button.sr-headless-checkout';
  const srCtaButton = document.querySelector(srCtaButtonSelector);
  const child = srCtaButton.querySelector('div.sr-d-flex.flex-center');
  child.classList.add('hide');

  const html = `
    <span class="od-btn-detail-wrap">
      <span class="secure-checkout-wrap">
        <img src="${lockIconUrl}">
        SECURE CHECKOUT
      </span>
      <span class="dot-wrap">•</span>
      <span class="price-wrap"></span>
    </span>    
  `;

  srCtaButton.insertAdjacentHTML('beforeend', html);
  srCtaButton.innerHtml += html;
}

function modifyCartPrice(priceInCents) {
  document.querySelector('#CartDrawer .od-btn-detail-wrap .price-wrap').textContent = theme.Currency.formatMoney(priceInCents);
}

async function updateCartData() {
  console.log('updateCartData');
  const cart = await LC_ShopifyHelper.getCart();
  if (cart) {
    modifyCartPrice(cart.total_price);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(async function () {
    modifyBuyNowButton();
    setTimeout(function () {
      updateCartData();
    }, 2200);
  }, 2000);

  document.addEventListener('cart:updated', function(event) {
    updateCartData();
  });

  document.addEventListener('ajaxProduct:added', function(event) {
    updateCartData();
  });
});
